import { PRODUCT_EXPERIENCES } from "app/constants";

// Les produits Combiné restent mono-destination : seuls Circuit/Autotour/Cruise
// couvrent plusieurs pays et doivent être exclus du comptage de pays ci-dessous.
export const isMultiStageJourneyProduct = product =>
	[
		PRODUCT_EXPERIENCES.CIRCUIT,
		PRODUCT_EXPERIENCES.AUTOTOUR,
		PRODUCT_EXPERIENCES.CRUISE,
	].includes(product?.productExperience);

const getDistinctCountries = products =>
	new Set(products?.map(product => product.country).filter(Boolean));

export const getDestinationGetter = products => {
	const singleDestinationCountries = getDistinctCountries(
		products?.filter(product => !isMultiStageJourneyProduct(product))
	);

	// Si aucun pays "réel" n'est identifié (résultats 100% multi-destination, ou pays
	// manquant sur les produits mono-destination), on retombe sur le comptage complet
	// pour éviter de masquer le filtre.
	const countries =
		singleDestinationCountries.size > 0
			? singleDestinationCountries
			: getDistinctCountries(products);

	return countries.size > 1 ? item => item.country : item => item.resort;
};
